// TODO: This should come from translation
export const TAGS_TRANSLATIONS: any = {
  "dnevnik": "Е-Дневник",
  "eTextbook": "Е-Учебници",
  "eLearning":  "Е-Обучение",
  "eMaterials": "Е-Съдържание",
  "administrative":  "Администрация",
  "popular": "Популярна"
}
